import Header from "./header";
import Slick from "./slick";
import MagnificPopup from "./magnific-popup";
import ContactForm from "./contact-form";
import AddToCart from "./add-to-cart";
import CartActionRequired from "./cart-action-required";
import CartNumItems from "./cart-num-items";
import CartTotal from "./cart-total";
import CartSmall from "./cart-small";
import Checkout from "./checkout";
import PasswordChange from "./password-change";
import OrderPagination from "./order-pagination";

export default {
    Header,
    Slick,
    MagnificPopup,
    ContactForm,
    AddToCart,
    CartNumItems,
    CartActionRequired,
    CartTotal,
    CartSmall,
    Checkout,
    PasswordChange,
    OrderPagination
}